import React from 'react';
import styled from '@emotion/styled';
import { Alert, Flex, Icon, Paragraph } from '@qga/roo-ui/components';
import pluralize from 'pluralize';

import Text from '@/components/Text';
import useDestination from '../../../../hooks/useDestination';

const Info = styled(Alert.info)`
  display: flex;
  justify-content: center;
`;

const Hint = React.memo(() => {
  const destination = useDestination();
  const nights = destination.searchConfig.minimumNights;
  return (
    <Info icon={null} mb="8">
      <Flex alignItems="center">
        <Icon name="info" mr="2" />
        <Paragraph mb="0">
          <Text bold>Enter your travel dates below</Text>
          &nbsp;to get the holiday prices.
          {nights && (
            <Text bold data-testid="MINIMUM_NIGHTS">
              &nbsp;
              {`Minimum stay of ${pluralize('night', nights, true)}`}
            </Text>
          )}
        </Paragraph>
      </Flex>
    </Info>
  );
});

export default Hint;
